module.exports = __webpack_public_path__ + "img/banner-events_1920x360-min.dfd7d85c.jpg";